import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Vehicles stats DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehiclesStatsDto extends BaseStatsDto {
  inPark!: number;
  outOfService!: number;
  hardHold!: number;
  sold!: number;
  scrapped!: number;
  reserved!: number;
  rented!: number;
  ordered!: number;
  leased!: number;
  inMaintenance!: number;
}
